/**
 * 专利卫士 涉及组织国家
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>涉及组织国家</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.country" style="width:160px" placeholder="输入组织国家名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="类型：">
        <el-select size="small" v-model="formInline.type" style="width:100px" placeholder="请选择">
          <el-option v-for="type in countryType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="状态：">
        <el-select size="small" v-model="formInline.status" style="width:100px" placeholder="请选择">
          <el-option v-for="type in countryStatus" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="80">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="80">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="name" align="center" label="名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="type" align="center" label="类型" :formatter="typeFormat" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="flag" align="center" label="旗帜" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column prop="flag" align="center" label="旗帜" width="120px" show-overflow-tooltip>
        <template slot-scope="scope" v-if="scope.row.flag">
        　  <img :src="scope.row.flag" width="90" height="48" />
        </template>
      </el-table-column>
      <el-table-column prop="sign" align="center" label="签名" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="sort" align="center" label="排序" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="status" align="center" label="类型" :formatter="statusFormat" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="120">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delCountry(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 详情界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm" :rules="infoFormRules">
        <el-row>
          <el-col :span="9">
            <el-form-item label="名称" prop="name">
              <el-input size="small" v-model="infoForm.name" placeholder="请输入名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="签名" prop="sign">
              <el-input size="small" v-model="infoForm.sign" placeholder="请输入签名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="排序值" prop="sort">
              <el-input size="small" v-model="infoForm.sort" placeholder="请输入排序值" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="类型" prop="type">
          <el-radio-group type="kind" v-model="infoForm.type"> 
                    <el-radio v-model="infoForm.type" :label="1" style="font-size: 25px">组织</el-radio>
                    <el-radio v-model="infoForm.type" :label="2">国家</el-radio>
                </el-radio-group>
        </el-form-item>
        <el-form-item label="状态" prop="status">
        <el-radio-group type="kind" v-model="infoForm.status"> 
                    <el-radio v-model="infoForm.status" :label="1" style="font-size: 25px">未启用</el-radio>
                    <el-radio v-model="infoForm.status" :label="2">已启用</el-radio>
                </el-radio-group>
        </el-form-item>
        <el-form-item label="旗帜" prop="flag">
              <el-upload
                class="avatar-uploader"
                action="https://zlbb.qzhip.com/index.php/index/base/uploadFile"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="infoForm.flag" :src="infoForm.flag" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveCountry('infoForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getCountryPageList, editCountry, delCountry, wechatUrl } from '../../api/wechatMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '',
      multipleSelection: [],
      infoForm: {
        id: '',
        name: '',
        type: '',
        flag: '',
        sign: '',
        sort: '',
        status: ''
      },
       formInline: {
        page: 1,
        ps: 10,
        name: '',
        type: 0,
        status: 0
      },
      listData: [], //用户数据
      countryType: [
        { key: '全部', value: 0 },
        { key: '组织', value: 1 },
        { key: '国家', value: 2 }
      ],
      countryStatus: [
        { key: '全部', value: 0 },
        { key: '未启用', value: 1 },
        { key: '已启用', value: 2 }
      ],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
         // 表单验证
      infoFormRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ],
        sign: [
          { required: true, message: '请输入签名', trigger: 'blur' }
        ],
        flag: [
          { required: true, message: '请上传旗帜', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序值', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择是否启用', trigger: 'blur' }
        ]
      },
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

        // 图片上传相关
    handleAvatarSuccess(res, file) {
      if(res.code == 200){
          // this.imageUrl = res.data.url;
          this.infoForm.flag = res.data.url
      }else{
          this.$message({
              type: 'error',
              message: res.msg
            })
      }
        // this.imageUrl = URL.createObjectURL(file.raw);
      },
    beforeAvatarUpload(file) {
        // const isJPG = file.type === 'image/jpeg';
        const isJPG = true;
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 10MB!');
        }
        return isJPG && isLt2M;
      },


    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getCountryPageList(parameter)
        .then(res => {
          this.loading = false
          res = checkLogin(res);
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 显示编辑页面
    handleEdit: function(index,row){
      if(row){
        this.infoForm.id = row.id
        this.infoForm.name = row.name
        this.infoForm.type = row.type
        this.infoForm.sign = row.sign
        this.infoForm.flag = row.flag
        this.infoForm.sort = row.sort
        this.infoForm.status = row.status
        this.title = '编辑信息'
      }else{
        this.title = '添加信息'
        this.infoForm.id = ''
        this.infoForm.name = ''
        this.infoForm.type = ''
        this.infoForm.sign = ''
        this.infoForm.flag = ''
        this.infoForm.sort = ''
        this.infoForm.status = ''
      }
      this.editFormVisible = true
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleInfo: function(index, row) {
      console.log(row)
      this.editFormVisible = true
      this.infoForm = row
    },
    // 保存组织国家
    saveCountry(infoForm){
        //校验参数
      this.$refs[infoForm].validate(valid => {
        if(valid){
           editCountry(this.infoForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
        }else{
          return false;
        }
      })
    },
    // 删除规费指引
    delCountry(index, row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        delGuide({id: row.id})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getdata()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    // 类型
    typeFormat:function(row,column){
        if(row.type == 1){
            return '组织'
        }else if(row.type == 2){
            return '国家'
        }else{
            return '未知'
        }
    },
    // 状态
    statusFormat:function(row,column){
        if(row.status == 1){
            return '未启用'
        }else if(row.status == 2){
            return '已启用'
        }else{
            return '未知'
        }
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #868484b5;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 180px;
  height: 96px;
  display: block;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/wechat/Country.vue